export function selectAll(contentEditableElement: HTMLSpanElement | HTMLDivElement | undefined | null) {
	if (!contentEditableElement) {
		return;
	}
	const selection = window.getSelection();
	const range = document.createRange();
	range.selectNodeContents(contentEditableElement);
	selection?.removeAllRanges();
	selection?.addRange(range);
}
